import { Button } from '@/components/ui/button';
import Image from 'next/image';
import Link from 'next/link';
import { HeroSuaEmpresaProps } from './suaempresa';

export default function MobileHeroSuaEmpresa({
  flag,
  titleOrange,
  titleWhite,
  description,
  buttonText,
  hrefButton,
}: HeroSuaEmpresaProps) {
  return (
    <div className="lg:hidden w-full relative">
      <div className="flex-1 bg-bluecaixa p-6 rounded-t-2xl">
        <div className="text-white space-y-4 flex flex-col items-center">
          {/* Texto com borda arredondada */}
          <div className="inline-block px-4 py-1 border-2 border-white rounded-full text-xs lg:text-sm">
            {flag}
          </div>

          {/* Título h1 com metade colorida */}
          <h1 className="text-4xl text-center font-extrabold leading-snug">
            <span className="text-orangecaixa">{titleOrange}</span>
            <span className="text-white"> {titleWhite}</span>
          </h1>

          <p className="text-base text-center font-thin leading-relaxed mb-2">
            {description}
          </p>

          <Button
            key={'Test'}
            variant={'ghost'}
            asChild
            className="text-white p-4 lg:p-8 lg:w-fit bg-orangecaixa"
          >
            <Link
              key={'para sua empresa'}
              href={hrefButton}
              className="flex items-center lg:gap-2 text-xs lg:text-sm lg:font-semibold text-white hover:text-stone-200"
            >
              <Image
                height={24}
                width={24}
                src={'/icons/arrow-right-circle.png'}
                alt={'right arrow icon'}
              />
              {buttonText}
            </Link>
          </Button>
        </div>
      </div>

      <div className="flex-1 bg-orangecaixa min-h-[265px] rounded-b-2xl"></div>

      <div className="w-full flex justify-center absolute bottom-0 left-1/2 transform -translate-x-1/2 z-10">
        <div className="relative">
          <Image
            src="/assets/hero-imgs/card-woman.png"
            alt="Imagem Central"
            height={261}
            width={234}
            priority={false}
          />
        </div>
      </div>
    </div>
  );
}

export function BannerStaticMobile({
  flag,
  titleOrange,
  titleWhite,
  description,
  buttonText,
  hrefButton,
  imgSrc = '',
}: HeroSuaEmpresaProps) {
  return (
    <div className="w-full relative aspect-[345/500] lg:hidden">
      <Link href={hrefButton} className="w-full h-full">
        <Image
          src={imgSrc.replace(/\.(png|jpg)$/, '-mobile.$1')}
          alt={`flag: ${flag} - title: ${titleOrange} ${titleWhite} - description: ${description} - ${buttonText}`}
          fill
          style={{ objectFit: 'cover' }}
          sizes="(max-width: 640px) 100vw, 640px"
          priority={false}
        />
      </Link>
    </div>
  );
}
